import * as Sentry from "@sentry/browser";
import * as React from "react";
import {Suspense} from "react";
import * as ReactDOM from "react-dom";
import ShopRatingSection from "./ShopRatingSection";

export class ShopRatingHandler {
  public static run(element: HTMLElement) {
    const shopId: number = Number(document.body.dataset.channel);
    const data = element.dataset.reactRating;

    if (!Number.isInteger(shopId)) {
      Sentry.captureException(new Error("SalesChannelId not found in DOM"));

      return;
    }

    if (data === undefined) {
      Sentry.captureException(new Error("Data attribute for Rating ItemIDs is missing or empty."));

      return;
    }

    Sentry.setExtra("SalesChannelId", shopId);

    const itemIds = data.split(",").map(Number);
    if (itemIds.length === 0) {
      Sentry.captureException(new Error("No itemIds available"));

      return;
    }

    ReactDOM.render(
      <Suspense fallback={"loading"}>
        <ShopRatingSection initialCommentsCount={5} loadMoreCommentsCount={5} shopId={shopId} itemIds={itemIds} />
      </Suspense>,
      element,
    );
  }
}
